import { render, staticRenderFns } from "./Letter.vue?vue&type=template&id=05c6448d&scoped=true&"
import script from "./Letter.vue?vue&type=script&lang=js&"
export * from "./Letter.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=05c6448d&scoped=true&lang=css&"
import style1 from "./Letter.vue?vue&type=style&index=1&id=05c6448d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c6448d",
  null
  
)

export default component.exports